import { ButtonSizes } from 'types';

export const buttonLineHeightBySizeDecorator = (size?: ButtonSizes) => {
	switch (size) {
		case 'small':
			return 'line-height: 0.6rem;';
		case 'large':
			return 'line-height: 2.4rem;';
		case 'medium':
		default:
			return 'line-height: 1.6rem;';
	}
};
